import { render, staticRenderFns } from "./CreateExtraVariable.vue?vue&type=template&id=57c9ac90"
import script from "./CreateExtraVariable.vue?vue&type=script&lang=js"
export * from "./CreateExtraVariable.vue?vue&type=script&lang=js"
import style0 from "./CreateExtraVariable.vue?vue&type=style&index=0&id=57c9ac90&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports